import type { CreateScreenRuleDTO } from '../contracts';

const clonePayload = (payload: CreateScreenRuleDTO): CreateScreenRuleDTO => ({
  name: payload.name,
  action: 'screen',
  settings: {
    ...(payload.settings.header !== undefined ? { header: { ...payload.settings.header } } : {}),
    ...(payload.settings.body !== undefined ? { body: { ...payload.settings.body } } : {}),
  },
});

/** Value object representing a complete screen-rule payload. */
export class ScreenRuleVO {
  readonly payload: CreateScreenRuleDTO;

  /**
   * Creates a screen-rule value object from a complete payload.
   * @param payload - The screen-rule payload to snapshot.
   */
  constructor(payload: CreateScreenRuleDTO) {
    this.payload = clonePayload(payload);
  }

  /**
   * Creates a value object from its JSON representation.
   * @param payload - The screen-rule JSON payload.
   * @returns A screen-rule value object containing a defensive snapshot.
   */
  static fromJSON(payload: CreateScreenRuleDTO): ScreenRuleVO {
    return new ScreenRuleVO(payload);
  }

  /**
   * Converts a screen-rule value object to JSON.
   * @param screenRuleVO - The screen-rule value object to serialize.
   * @returns A defensive copy of the screen-rule payload.
   */
  static toJSON(screenRuleVO: ScreenRuleVO): CreateScreenRuleDTO {
    return clonePayload(screenRuleVO.payload);
  }
}
